import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import About from '../components/About';
import FinalCTA from '../components/FinalCTA';
import WhatsAppFloat from '../components/WhatsAppFloat';

const AboutPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#030712] text-white flex flex-col font-sans">
      <Navbar />

      <main className="flex-1 pt-24">
        {/* Banner */}
        <div className="bg-[#030712] py-16 border-b border-white/10 text-center">
          <div className="max-w-4xl mx-auto px-4">
            <span className="font-mono text-xs uppercase tracking-widest text-sky-400 font-semibold block mb-2">
              Corporate Overview
            </span>
            <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-white mb-4">
              About <span className="gradient-text">Zynqora Edge</span>
            </h1>
            <p className="text-slate-400 text-base max-w-xl mx-auto font-normal">
              An enterprise AI &amp; custom software engineering house delivering production systems to startups and enterprises across the USA, Canada, and global markets.
            </p>
          </div>
        </div>

        {/* Main About Component on White Surface */}
        <About />

        {/* Final CTA */}
        <FinalCTA />
      </main>

      <WhatsAppFloat />
    </div>
  );
};

export default AboutPage;
